import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-info-card-link',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './info-card-link.component.html',
})
export class InfoCardLinkComponent {
  readonly text = input<string>();
  readonly color = input<string>();
  readonly icon = input<string>();
  readonly dataTest = input<string>();
  readonly actionClicked = output<void>();
  index = input<number>();
}
